/**
 * The ids RelatedVenues offers as sister venues, plus the venue's own: the
 * shape useRelatedVenues has always returned (sorted, the venue included), for
 * venuesForPlaceIds to resolve against the catalog.
 *
 * The sisters are the venue's city pool from booking-api (partnerVenues,
 * booking-api#75): the venues in the same city, which also share one set of
 * table codes. An empty pool means no sisters, even where the catalog's
 * `?places=` lists some: Helsingborg's and Malmö's list closed venues. The
 * catalog list is used only when the pool cannot be fetched at all, such as
 * before booking-api#75 is out, so the page never loses its sisters to a
 * release order. While the pool loads there are none, so the page does not
 * show one list and then another.
 */
export function sisterVenueIds({
  ownId,
  pool,
  poolFailed,
  catalogRelated,
}: {
  ownId?: string;
  pool?: string[];
  poolFailed: boolean;
  catalogRelated?: string[];
}): string[] {
  let sisters: string[] = [];
  if (Array.isArray(pool)) {
    sisters = pool;
  } else if (poolFailed) {
    sisters = catalogRelated || [];
  }
  const ids = [...sisters, ...(ownId ? [ownId] : [])].filter(
    (id) => typeof id === 'string' && id !== '',
  );
  return [...new Set(ids)].sort((a, b) => a.localeCompare(b));
}
